import useWindowDimensions from '../../hooks/useWindowDimensions';
import QRCode from 'react-qr-code';

type QRCodeProps = {
    size: number;
    style?: string;
    value: string;
    fgColor: string;
    viewBox?: string;
};
export const QrCodeGenerator = ({
    value,
    fgColor = '#030712',
    size,
}: QRCodeProps) => {
    const dimensions = useWindowDimensions();
    return (
        <div className="p-3 bg-white xrounded-md aspect-square flex items-center justify-center">
            <QRCode
                value={value}
                fgColor={fgColor}
                size={size}
            />
        </div>
    );
};
